import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  // mode:'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        },
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力',
              description:
                '酒泉民信热力发展有限公司是一家以从事电力、热力生产和供应业为主的企业，公司大力推进国有企业改革深化提升行动，增强企业核心功能，提升企业核心竞争力。'
            }
          }
        },
        {
          path: '/about',
          name: 'about',
          component: resolve => require(['@/view/About/About-MX'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，关于民信',
              description:
                '酒泉民信热力发展有限公司是一家以从事电力、热力生产和供应业为主的企业，公司大力推进国有企业改革深化提升行动，增强企业核心功能，提升企业核心竞争力。'
            }
          },
          children: []
        },
        {
          path: '/about/dm1',
          name: 'about1',
          component: resolve => require(['@/view/About/Company-Overview'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '企业概况',
              description:
                '酒泉民信热力发展有限公司，成立于2022年，位于甘肃省酒泉市肃州区，是一家以从事电力、热力生产和供应业为主的企业，公司大力推进国有企业改革深化提升行动，增强企业核心功能，提升企业核心竞争力。'
            }
          }
        },
        {
          path: '/about/dm2',
          name: 'about2',
          component: resolve => require(['@/view/About/Social-Honor'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '企业概况',
              description:
                '酒泉民信热力发展有限公司，成立于2022年，位于甘肃省酒泉市肃州区，是一家以从事电力、热力生产和供应业为主的企业，公司大力推进国有企业改革深化提升行动，增强企业核心功能，提升企业核心竞争力。'
            }
          }
        },
        {
          path: '/about/dm3',
          name: 'about3',
          component: resolve => require(['@/view/About/Corporate-Culture'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，企业荣誉',
              description: '民信热力企业荣誉'
            }
          }
        },
        {
          path: '/about/dm4',
          name: 'about4',
          component: resolve => require(['@/view/About/Organization-Structure'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，企业文化',
              description: '民信热力企业文化'
            }
          }
        },
        {
          path: '/about/dm5',
          name: 'about5',
          component: resolve => require(['@/view/About/Enterprise-Chronicles'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，企业架构',
              description: '民信热力企业架构'
            }
          }
        },
        {
          path: '/about/dm6',
          name: 'about6',
          component: resolve => require(['@/view/About/Heating-Mien'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，大事记',
              description: '民信热力大事记'
            }
          }
        },
        {
          path: '/about/rydetail',
          name: 'about7',
          component: resolve => require(['@/view/About/Detail/Honor-Detail'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力',
              description: '民信热力详细信息'
            }
          }
        },
        {
          path: '/about/fcdetail',
          name: 'about8',
          component: resolve => require(['@/view/About/Detail/Heat-Detail'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力',
              description: '民信热力详细信息'
            }
          }
        },
        {
          path: '/about/whdetail',
          name: 'about9',
          component: resolve => require(['@/view/About/Detail/Culture-Detail'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力',
              description: '民信热力详细信息'
            }
          }
        },
        {
          path: '/about/dsjdetail',
          name: 'about10',
          component: resolve => require(['@/view/About/Detail/Chr-Detail'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力',
              description: '民信热力详细信息'
            }
          }
        },
        {
          path: '/party',
          name: 'party',
          component: resolve => require(['@/view/Party/Party-MX'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，党建工作',
              description:
                '中国共产党成立100多年，充分发挥榜样示范引领作用，教育引导广大党员干部挺起民族脊梁，坚定民族自信，提升履职能力，谱写新时代特色社会主义现代化企业建设新篇章。'
            }
          }
        },

        {
          name: 'party1',
          path: '/party/1',
          component: resolve => require(['@/view/Party/Party-Constitution'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，党建工作',
              description:
                '中国共产党成立100多年，充分发挥榜样示范引领作用，教育引导广大党员干部挺起民族脊梁，坚定民族自信，提升履职能力，谱写新时代特色社会主义现代化企业建设新篇章。'
            }
          }
        },
        {
          name: 'party2',
          path: '/party/2',
          component: resolve => require(['@/view/Party/Party-Work'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，党建工作',
              description:
                '中国共产党成立100多年，充分发挥榜样示范引领作用，教育引导广大党员干部挺起民族脊梁，坚定民族自信，提升履职能力，谱写新时代特色社会主义现代化企业建设新篇章。'
            }
          }
        },
        {
          name: 'party3',
          path: '/party/3',
          component: resolve => require(['@/view/Party/Party-Honest'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，党建工作',
              description:
                '中国共产党成立100多年，充分发挥榜样示范引领作用，教育引导广大党员干部挺起民族脊梁，坚定民族自信，提升履职能力，谱写新时代特色社会主义现代化企业建设新篇章。'
            }
          }
        },
        {
          path: '/party/dtdetail',
          name: 'party4',
          component: resolve => require(['@/view/Party/Detail/Party-Dt'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，党建工作',
              description:
                '中国共产党成立100多年，充分发挥榜样示范引领作用，教育引导广大党员干部挺起民族脊梁，坚定民族自信，提升履职能力，谱写新时代特色社会主义现代化企业建设新篇章。'
            }
          }
        },
        {
          path: '/party/dwdetail',
          name: 'party5',
          component: resolve => require(['@/view/Party/Detail/Party-Dw'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，党建工作',
              description:
                '中国共产党成立100多年，充分发挥榜样示范引领作用，教育引导广大党员干部挺起民族脊梁，坚定民族自信，提升履职能力，谱写新时代特色社会主义现代化企业建设新篇章。'
            }
          }
        },
        {
          path: '/party/lzdetail',
          name: 'party6',
          component: resolve => require(['@/view/Party/Detail/Party-Lz'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，党建工作',
              description:
                '中国共产党成立100多年，充分发挥榜样示范引领作用，教育引导广大党员干部挺起民族脊梁，坚定民族自信，提升履职能力，谱写新时代特色社会主义现代化企业建设新篇章。'
            }
          }
        },
        {
          name: 'news',
          path: '/news',
          component: resolve => require(['@/view/News/News-MX'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，新闻中心',
              description: '积极推动供热管道回收，低碳助力供热空间拓展'
            }
          }
        },
        {
          name: 'news1',
          path: '/news/1',
          component: resolve => require(['@/view/News/Corporate-News'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，新闻中心',
              description: '积极推动供热管道回收，低碳助力供热空间拓展'
            }
          }
        },
        {
          name: 'news2',
          path: '/news/2',
          component: resolve => require(['@/view/News/Company-Announcement'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，新闻中心',
              description: '积极推动供热管道回收，低碳助力供热空间拓展'
            }
          }
          //redirect: '/News/Company_Announcement'
        },
        {
          name: 'news3',
          path: '/news/3',
          component: resolve => require(['@/view/News/Media-coverage'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，新闻中心',
              description: '积极推动供热管道回收，低碳助力供热空间拓展'
            }
          }
        },
        {
          name: 'news4',
          path: '/news/4',
          component: resolve => require(['@/view/News/Industry-news'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，新闻中心',
              description: '积极推动供热管道回收，低碳助力供热空间拓展'
            }
          }
          //redirect: '/News/Company_Announcement'
        },
        {
          name: 'news5',
          path: '/news/5',
          component: resolve => require(['@/view/News/Social-Responsibility'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，新闻中心',
              description: '积极推动供热管道回收，低碳助力供热空间拓展'
            }
          }
        },
        {
          path: '/news/newstzdetail',
          name: 'news6',
          component: resolve => require(['@/view/News/Detail/News-Tzgg'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，新闻中心',
              description: '积极推动供热管道回收，低碳助力供热空间拓展'
            }
          }
        },
        {
          path: '/news/newsqydetail',
          name: 'news7',
          component: resolve => require(['@/view/News/Detail/News-Qyxw'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，新闻中心',
              description: '积极推动供热管道回收，低碳助力供热空间拓展'
            }
          }
        },
        {
          path: '/news/newsmtdetail',
          name: 'news8',
          component: resolve => require(['@/view/News/Detail/News-Mtbd'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，新闻中心',
              description: '积极推动供热管道回收，低碳助力供热空间拓展'
            }
          }
        },
        {
          path: '/news/newshydetail',
          name: 'news9',
          component: resolve => require(['@/view/News/Detail/News-Hyxw'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，新闻中心',
              description: '积极推动供热管道回收，低碳助力供热空间拓展'
            }
          }
        },
        {
          name: 'project',
          path: '/project',

          component: resolve => require(['@/view/Project/Project-MX'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，新闻中心',
              description: '积极推动供热管道回收，低碳助力供热空间拓展'
            }
          }
        },

        {
          name: 'project1',
          path: '/project/1',
          component: resolve => require(['@/view/Project/Heat-exchange'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，老旧管网',
              description:
                '酒钢集团-酒泉市肃州区热电联产集中供热项目建设和老旧小区管网改造工作持续稳步推进，六月至八月为高温酷暑天气和汛期，为避免出现事故发生和冲毁在建设施，酒泉民信热力发展有限公司持续加大巡查巡检频次与力度，保障项目建设安全有序进行。'
            }
          }
        },
        {
          name: 'project2',
          path: '/project/2',
          component: resolve => require(['@/view/Project/Heating-pipeline'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，老旧管网',
              description:
                '酒泉民信热力发展有限公司作为酒泉市肃州区城区供热管网改造工程项目（二期）承建方，对项目已完工及未完工共计十三个标段，开展了工程竣工质量预验收工作。'
            }
          }
        },
        {
          name: 'project3',
          path: '/project/3',
          component: resolve => require(['@/view/Project/New-energy'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，老旧管网',
              description:
                '酒钢集团-酒泉市肃州区热电联产集中供热项目建设和老旧小区管网改造工作持续稳步推进，六月至八月为高温酷暑天气和汛期，为避免出现事故发生和冲毁在建设施，酒泉民信热力发展有限公司持续加大巡查巡检频次与力度，保障项目建设安全有序进行。'
            }
          }
        },
        {
          path: '/project/projecthrzdetail',
          name: 'project4',
          component: resolve => require(['@/view/Project/Detail/Project-Hrz'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，老旧管网',
              description:
                '酒泉民信热力发展有限公司作为酒泉市肃州区城区供热管网改造工程项目（二期）承建方，对项目已完工及未完工共计十三个标段，开展了工程竣工质量预验收工作。'
            }
          }
        },
        {
          path: '/project/projectrlgwdetail',
          name: 'project5',
          component: resolve => require(['@/view/Project/Detail/Project-Rlgw'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，老旧管网',
              description:
                '酒钢集团-酒泉市肃州区热电联产集中供热项目建设和老旧小区管网改造工作持续稳步推进，六月至八月为高温酷暑天气和汛期，为避免出现事故发生和冲毁在建设施，酒泉民信热力发展有限公司持续加大巡查巡检频次与力度，保障项目建设安全有序进行。'
            }
          }
        },
        {
          path: '/project/projectxnydetail',
          name: 'project6',
          component: resolve => require(['@/view/Project/Detail/Project-Xny'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，老旧管网',
              description:
                '酒泉民信热力发展有限公司作为酒泉市肃州区城区供热管网改造工程项目（二期）承建方，对项目已完工及未完工共计十三个标段，开展了工程竣工质量预验收工作。'
            }
          }
        },
        {
          path: '/production',
          name: 'production',
          component: resolve => require(['@/view/production/Production-MX'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，安全生产',
              description:
                '酒钢集团-酒泉市肃州区热电联产集中供热项目是酒、嘉两地深化区域协同发展，加速建设酒嘉“双城经济圈”战略合作的省列重点项目，对推动两地经济社会高质量发展具有重要意义。项目建成后将替代酒泉市热力公司热源厂、春光热力热源厂、昌恒热力热源厂、经开区（西园）热源厂，形成与酒泉城区华能热电联产供热系统实现双热源保障，互为备用的供热新格局。'
            }
          }
        },

        {
          name: 'production1',
          path: '/production/1',
          component: resolve => require(['@/view/Production/Production-Culture'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，安全生产',
              description:
                '酒钢集团-酒泉市肃州区热电联产集中供热项目是酒、嘉两地深化区域协同发展，加速建设酒嘉“双城经济圈”战略合作的省列重点项目，对推动两地经济社会高质量发展具有重要意义。项目建成后将替代酒泉市热力公司热源厂、春光热力热源厂、昌恒热力热源厂、经开区（西园）热源厂，形成与酒泉城区华能热电联产供热系统实现双热源保障，互为备用的供热新格局。'
            }
          }
        },
        {
          name: 'production2',
          path: '/production/2',
          component: resolve => require(['@/view/Production/Production-Safe'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，安全生产',
              description:
                '酒钢集团-酒泉市肃州区热电联产集中供热项目是酒、嘉两地深化区域协同发展，加速建设酒嘉“双城经济圈”战略合作的省列重点项目，对推动两地经济社会高质量发展具有重要意义。项目建成后将替代酒泉市热力公司热源厂、春光热力热源厂、昌恒热力热源厂、经开区（西园）热源厂，形成与酒泉城区华能热电联产供热系统实现双热源保障，互为备用的供热新格局。'
            }
          }
        },
        {
          name: 'production3',
          path: '/production/3',
          component: resolve => require(['@/view/Production/Production-Publicity'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，安全生产',
              description:
                '酒钢集团-酒泉市肃州区热电联产集中供热项目是酒、嘉两地深化区域协同发展，加速建设酒嘉“双城经济圈”战略合作的省列重点项目，对推动两地经济社会高质量发展具有重要意义。项目建成后将替代酒泉市热力公司热源厂、春光热力热源厂、昌恒热力热源厂、经开区（西园）热源厂，形成与酒泉城区华能热电联产供热系统实现双热源保障，互为备用的供热新格局。'
            }
          }
        },
        {
          name: 'production4',
          path: '/production/culdetail',
          component: resolve => require(['@/view/Production/Detail/Production-Wh'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，安全生产',
              description:
                '酒钢集团-酒泉市肃州区热电联产集中供热项目是酒、嘉两地深化区域协同发展，加速建设酒嘉“双城经济圈”战略合作的省列重点项目，对推动两地经济社会高质量发展具有重要意义。项目建成后将替代酒泉市热力公司热源厂、春光热力热源厂、昌恒热力热源厂、经开区（西园）热源厂，形成与酒泉城区华能热电联产供热系统实现双热源保障，互为备用的供热新格局。'
            }
          }
        },
        {
          name: 'production5',
          path: '/production/safedetail',
          component: resolve => require(['@/view/Production/Detail/Production-Sc'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，安全生产',
              description:
                '酒钢集团-酒泉市肃州区热电联产集中供热项目是酒、嘉两地深化区域协同发展，加速建设酒嘉“双城经济圈”战略合作的省列重点项目，对推动两地经济社会高质量发展具有重要意义。项目建成后将替代酒泉市热力公司热源厂、春光热力热源厂、昌恒热力热源厂、经开区（西园）热源厂，形成与酒泉城区华能热电联产供热系统实现双热源保障，互为备用的供热新格局。'
            }
          }
        },
        {
          name: 'production6',
          path: '/production/publicitydetail',
          component: resolve => require(['@/view/Production/Detail/Production-Xj'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，安全生产',
              description:
                '酒钢集团-酒泉市肃州区热电联产集中供热项目是酒、嘉两地深化区域协同发展，加速建设酒嘉“双城经济圈”战略合作的省列重点项目，对推动两地经济社会高质量发展具有重要意义。项目建成后将替代酒泉市热力公司热源厂、春光热力热源厂、昌恒热力热源厂、经开区（西园）热源厂，形成与酒泉城区华能热电联产供热系统实现双热源保障，互为备用的供热新格局。'
            }
          }
        },
        {
          name: 'service',
          path: '/service',

          component: resolve => require(['@/view/Service/Service-MX'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，服务理念',
              description:
                '酒钢集团-1.客户至上：我们始终将客户的需求放在首位，以满足客户需求为首要任务，不断提升服务品质，让客户享受到优质的供暖服务。 2.诚信经营：我们始终秉持诚信原则，严格遵守合同约定，确保供暖服务的质量和安全，树立良好的企业形象。 3.创新发展：我们不断探索新技术、新模式，推动供暖服务的创新发展，提高供暖服务的竞争力和可持续性。 4.环保节能：我们注重环保节能，采取先进的节能技术和环保措施，降低能源消耗和排放，实现经济效益和社会效益的双赢。 5.优质服务：我们致力于提供优质的服务，包括热情周到的接待、专业高效的维修、安全可靠的供暖设备等，让客户享受到贴心、便捷的服务体验。'
            }
          }
        },

        {
          name: 'service1',
          path: '/service/1',
          component: resolve => require(['@/view/Service/Service-Commitment'], resolve), //服务理念
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，服务理念',
              description:
                '酒钢集团-1.客户至上：我们始终将客户的需求放在首位，以满足客户需求为首要任务，不断提升服务品质，让客户享受到优质的供暖服务。 2.诚信经营：我们始终秉持诚信原则，严格遵守合同约定，确保供暖服务的质量和安全，树立良好的企业形象。 3.创新发展：我们不断探索新技术、新模式，推动供暖服务的创新发展，提高供暖服务的竞争力和可持续性。 4.环保节能：我们注重环保节能，采取先进的节能技术和环保措施，降低能源消耗和排放，实现经济效益和社会效益的双赢。 5.优质服务：我们致力于提供优质的服务，包括热情周到的接待、专业高效的维修、安全可靠的供暖设备等，让客户享受到贴心、便捷的服务体验。'
            }
          }
        },
        {
          name: 'service2',
          path: '/service/2',
          component: resolve => require(['@/view/Service/Charging-Policy'], resolve), //政策
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，政策法规',
              description:
                '酒钢集团-1.客户至上：我们始终将客户的需求放在首位，以满足客户需求为首要任务，不断提升服务品质，让客户享受到优质的供暖服务。 2.诚信经营：我们始终秉持诚信原则，严格遵守合同约定，确保供暖服务的质量和安全，树立良好的企业形象。 3.创新发展：我们不断探索新技术、新模式，推动供暖服务的创新发展，提高供暖服务的竞争力和可持续性。 4.环保节能：我们注重环保节能，采取先进的节能技术和环保措施，降低能源消耗和排放，实现经济效益和社会效益的双赢。 5.优质服务：我们致力于提供优质的服务，包括热情周到的接待、专业高效的维修、安全可靠的供暖设备等，让客户享受到贴心、便捷的服务体验。'
            }
          }
        },
        {
          name: 'service3',
          path: '/service/3',
          component: resolve => require(['@/view/Service/Installation-process'], resolve), //缴费流程
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，缴费流程',
              description:
                '酒钢集团-1.客户至上：我们始终将客户的需求放在首位，以满足客户需求为首要任务，不断提升服务品质，让客户享受到优质的供暖服务。 2.诚信经营：我们始终秉持诚信原则，严格遵守合同约定，确保供暖服务的质量和安全，树立良好的企业形象。 3.创新发展：我们不断探索新技术、新模式，推动供暖服务的创新发展，提高供暖服务的竞争力和可持续性。 4.环保节能：我们注重环保节能，采取先进的节能技术和环保措施，降低能源消耗和排放，实现经济效益和社会效益的双赢。 5.优质服务：我们致力于提供优质的服务，包括热情周到的接待、专业高效的维修、安全可靠的供暖设备等，让客户享受到贴心、便捷的服务体验。'
            }
          }
        },
        {
          name: 'service4',
          path: '/service/4',
          component: resolve => require(['@/view/Service/Service-StartStopHeat'], resolve), //供停暖
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，服务理念',
              description:
                '酒钢集团-1.客户至上：我们始终将客户的需求放在首位，以满足客户需求为首要任务，不断提升服务品质，让客户享受到优质的供暖服务。 2.诚信经营：我们始终秉持诚信原则，严格遵守合同约定，确保供暖服务的质量和安全，树立良好的企业形象。 3.创新发展：我们不断探索新技术、新模式，推动供暖服务的创新发展，提高供暖服务的竞争力和可持续性。 4.环保节能：我们注重环保节能，采取先进的节能技术和环保措施，降低能源消耗和排放，实现经济效益和社会效益的双赢。 5.优质服务：我们致力于提供优质的服务，包括热情周到的接待、专业高效的维修、安全可靠的供暖设备等，让客户享受到贴心、便捷的服务体验。'
            }
          }
        },
        // {
        //   name: 'service5',
        //   path: '/service/5',
        //   component: resolve => require(['@/view/Service/Heating-range'], resolve),//范围
        //   meta: {
        //     title: '酒泉民信热力发展有限公司'
        //   }
        // },
        {
          name: 'service6',
          path: '/service/6',
          component: resolve => require(['@/view/Service/Service-outlets'], resolve), //网点
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，服务理念',
              description:
                '酒钢集团-1.客户至上：我们始终将客户的需求放在首位，以满足客户需求为首要任务，不断提升服务品质，让客户享受到优质的供暖服务。 2.诚信经营：我们始终秉持诚信原则，严格遵守合同约定，确保供暖服务的质量和安全，树立良好的企业形象。 3.创新发展：我们不断探索新技术、新模式，推动供暖服务的创新发展，提高供暖服务的竞争力和可持续性。 4.环保节能：我们注重环保节能，采取先进的节能技术和环保措施，降低能源消耗和排放，实现经济效益和社会效益的双赢。 5.优质服务：我们致力于提供优质的服务，包括热情周到的接待、专业高效的维修、安全可靠的供暖设备等，让客户享受到贴心、便捷的服务体验。'
            }
          }
        },
        {
          name: 'service7',
          path: '/service/7',
          component: resolve => require(['@/view/Service/Heating-tips'], resolve), //常识
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，服务理念',
              description:
                '酒钢集团-1.客户至上：我们始终将客户的需求放在首位，以满足客户需求为首要任务，不断提升服务品质，让客户享受到优质的供暖服务。 2.诚信经营：我们始终秉持诚信原则，严格遵守合同约定，确保供暖服务的质量和安全，树立良好的企业形象。 3.创新发展：我们不断探索新技术、新模式，推动供暖服务的创新发展，提高供暖服务的竞争力和可持续性。 4.环保节能：我们注重环保节能，采取先进的节能技术和环保措施，降低能源消耗和排放，实现经济效益和社会效益的双赢。 5.优质服务：我们致力于提供优质的服务，包括热情周到的接待、专业高效的维修、安全可靠的供暖设备等，让客户享受到贴心、便捷的服务体验。'
            }
          }
        },
        {
          name: 'service8',
          path: '/service/serviceSfdetail',
          component: resolve => require(['@/view/Service/Detail/Production-Zc'], resolve), //政策详细
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，服务理念',
              description:
                '酒钢集团-1.客户至上：我们始终将客户的需求放在首位，以满足客户需求为首要任务，不断提升服务品质，让客户享受到优质的供暖服务。 2.诚信经营：我们始终秉持诚信原则，严格遵守合同约定，确保供暖服务的质量和安全，树立良好的企业形象。 3.创新发展：我们不断探索新技术、新模式，推动供暖服务的创新发展，提高供暖服务的竞争力和可持续性。 4.环保节能：我们注重环保节能，采取先进的节能技术和环保措施，降低能源消耗和排放，实现经济效益和社会效益的双赢。 5.优质服务：我们致力于提供优质的服务，包括热情周到的接待、专业高效的维修、安全可靠的供暖设备等，让客户享受到贴心、便捷的服务体验。'
            }
          }
        },
        {
          name: 'feedback',
          path: '/feedback',
          component: resolve => require(['@/view/Feedback/Feedback-MX'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，用户反馈',
              description: '反馈供热问题，用户反馈'
            }
          }
        },
        {
          name: 'contactus',
          path: '/contactus',
          component: resolve => require(['@/view/HR/HR-MX'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，招聘',
              description: '招贤纳士'
            }
          }
        },
        {
          name: 'contactus1',
          path: '/contactus/1',
          component: resolve => require(['@/view/HR/JobChance'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，招聘',
              description: '招贤纳士'
            }
          }
        },
        {
          name: 'contactus3',
          path: '/contactus/jobdetail',
          component: resolve => require(['@/view/HR/Detail/Detail-job'], resolve),
          meta: {
            metaInfo: {
              title: '酒泉民信热力-优质供热服务的提供者',
              keywords: '民信热力，招聘',
              description: '招贤纳士'
            }
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js